import Lenis from 'lenis'
import { useEffect } from 'react'

// Instance partagée : ScrollToTop (repositionnement à la navigation) et le
// CookieBanner (stop pendant le panneau de préférences) pilotent le même Lenis.
let lenis: Lenis | null = null

export function getLenis(): Lenis | null {
  return lenis
}

/**
 * Monté dans App (client) et jamais dans AppShell : le prérendu ne doit pas
 * connaître Lenis. Si prefers-reduced-motion est actif, on ne monte rien et
 * tout retombe sur le scroll natif — y compris les fallbacks de ScrollToTop.
 */
export function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    // Config par défaut (lerp 0.1, wheel seulement) : le tactile reste natif,
    // le smoothing touch dégrade le feel iOS/Android.
    const instance = new Lenis()
    lenis = instance

    let rafId = requestAnimationFrame(function loop(time) {
      instance.raf(time)
      rafId = requestAnimationFrame(loop)
    })

    return () => {
      cancelAnimationFrame(rafId)
      instance.destroy()
      lenis = null
    }
  }, [])

  return null
}
